import { cn } from '@/lib/cn.js';

/** True when the string contains HTML markup (not just plain text). */
export function looksLikeHtml(value) {
  if (!value || typeof value !== 'string') return false;
  return /<[a-z][\s\S]*>/i.test(value);
}

/**
 * Renders CMS content that may be plain text or sanitized HTML.
 * Plain text is shown as-is; HTML is injected via dangerouslySetInnerHTML.
 */
export function HtmlContent({ html, className, as: Tag = 'div' }) {
  if (html == null || html === '') return null;

  if (looksLikeHtml(html)) {
    return (
      <Tag
        className={cn(
          'cms-html text-base leading-relaxed [&_a]:text-brand-600 [&_a]:underline [&_a]:underline-offset-2 dark:[&_a]:text-brand-300',
          '[&_code]:rounded [&_code]:bg-ink-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.9em] dark:[&_code]:bg-ink-800',
          '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-2',
          className,
        )}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return <Tag className={className}>{html}</Tag>;
}
